import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";
import { errorToast, successToast } from "../../../utils/toasts";

export function useUpdateProductAdState() {
  const queryClient = useQueryClient();
  const { t } = useTranslation(["advertising"]);
  return useMutation({
    mutationFn: async (vars: {
      custom_api_request: "pause_product_ad";
      id: number;
      state: number;
      products: number[];
    }) => {
      await apiClient.updateProductAdStatus(vars);
    },
    onSuccess: () => {
      successToast({ message: t(($) => $.advertising["Product Ad Status Successfully Updated"]) });
      void queryClient.invalidateQueries({
        predicate: (query) => {
          const stringifiedQueryKey = JSON.stringify(query.queryKey);
          return stringifiedQueryKey.toLowerCase().includes("productads");
        },
      });
    },
    onError: (error) => {
      errorToast({ message: t(($) => $.advertising["Failed to Update Product Ad Status"]), error });
    },
  });
}
